












































































































































































































































import {Vue, Component, Provide, Emit, Watch} from 'vue-property-decorator';
import {API} from '@/services/api/api';
import {getImage, Utils} from '@/utils/Utils';
import {mapActions, mapGetters} from 'vuex';
import Drift from 'drift-zoom';
import {findDeckMarkerInDeckImg} from '@/utils/DeckOperations';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import canvasMerge from '@/utils/CanvasMerge';
import {debounce} from 'ts-debounce';
@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['shipList'])},
})
export default class CreateZone extends Vue {
  isScreenLoading = false;

  commonValidationMsg = 'This field is required';
  drift: any;

  shipList: [];
  zoneData = [
    {
      zoneName: '',
      zoneValidationMsg: '',
      remarks: '',
      remarkValidationMsg: '',
      endPointOfZone: null,
      startPointOfZone: null,
      startPointValidationMsg: '',
      endPointValidationMsg: '',
      zoneStatus: false,
    },
  ];

  shipValidationMsg = '';
  deckValidationMsg = '';
  selectedShipId: number = null;
  deckName = null;
  deckImageURL = '';
  createdImage = null;
  deckList = [];

  showSuccessToast: any;
  showErrorToast: any;
  shipsDetails = [];

  btnLoader = false;
  cropper = null;
  focusedStartPoint = null;
  // find zones
  scandResult: any = null;
  // end find zones

  //initialize form with empty value
  init() {
    this.selectedShipId = null;
    this.shipValidationMsg = '';
    this.deckValidationMsg = '';
    this.deckList = [];
    this.deckName = null;
    this.deckImageURL = '';
    this.createdImage = null;
    this.scandResult = null;
    this.zoneData = [
      {
        zoneName: '',
        zoneValidationMsg: '',
        remarks: '',
        remarkValidationMsg: '',
        endPointOfZone: null,
        startPointOfZone: null,
        startPointValidationMsg: '',
        endPointValidationMsg: '',
        zoneStatus: false,
      },
    ];
  }

  isAutomatedEnable = true;

  //toggle between manual and automatic mode
  onToggle() {
    this.isAutomatedEnable = !this.isAutomatedEnable;
    if (!this.isAutomatedEnable) {
      this.initCropper();
    } else {
      this.destroyCropper();
    }
  }

  // change handler deck
  changeDeck() {
    // this.validateShipSelect();
    this.resetZoneData();
    this.validateDeckSelect();
    this.showDeckImage();
  }

  // validate ship selected
  validateShipSelect() {
    if (this.selectedShipId === null || this.selectedShipId.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.shipValidationMsg = '';
      return true;
    }
  }

  // Validate Deck selected
  validateDeckSelect() {
    if (this.deckName === null || this.deckName.length < 1) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.deckValidationMsg = '';

      return true;
    }
  }

  //Get decks from api after select ship, by ID
  async getDecksByShipId() {
    try {
      this.deckName = null;
      this.isScreenLoading = true;
      const params = {
        alldecks: 0,
        withoutzones: 1,
        withoutcenter: 0,
      };
      const response = await API.fetchEmptyDecksByShipId(params, this.selectedShipId);

      if (response.data) {
        const data = response.data;
        this.deckList = data.drawings;
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    } finally {
      this.isScreenLoading = false;
    }
  }
  // Validate zone data
  validateZone() {
    let retrunVar = true;
    this.zoneData.map((obj, index) => {
      this.zoneData[index].zoneValidationMsg = this.zoneData[index].remarkValidationMsg = this.zoneData[
        index
      ].endPointValidationMsg = this.zoneData[index].startPointValidationMsg = '';
      if (obj.zoneName === '') {
        this.zoneData[index].zoneValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      }
      if (obj.remarks === '') {
        this.zoneData[index].remarkValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      }

      if (obj.startPointOfZone === null || obj.startPointOfZone === '') {
        this.zoneData[index].startPointValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      }
      if (obj.endPointOfZone === null) {
        this.zoneData[index].endPointValidationMsg = this.commonValidationMsg;
        retrunVar = false;
      } else if (Number(obj.startPointOfZone) >= Number(obj.endPointOfZone)) {
        this.zoneData[index].endPointValidationMsg = 'End point of zone must be greater than start point';
        retrunVar = false;
      }
    });
    this.renderLine();
    return retrunVar;
  }

  // Validate all from
  validateAll() {
    return this.validateShipSelect() && this.validateDeckSelect() && this.validateZone();
  }

  // Submit form
  async _saveHandler() {
    if (this.validateAll()) {
      try {
        this.btnLoader = true;
        const ZoneMasters = this.zoneData.map((obj) => {
          return {
            zoneEndPoint: obj.endPointOfZone,
            zoneStartPoint: obj.startPointOfZone,

            isActive: obj.zoneStatus,
            remarks: obj.remarks,
            zoneName: obj.zoneName,
          };
        });
        const response = await API.createZone({
          drawingId: this.deckName,
          ZoneMasters,
        });
        if (response.data) {
          this.showSuccessToast({msg: response.message});

          this.changeTabs();
          this.init();
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.btnLoader = false;
      }
    }
  }

  // Add deck row UI
  addZone(length: number) {
    if (length === 0 || this.validateZone()) {
      this.zoneData.push({
        zoneName: '',
        zoneValidationMsg: '',
        remarks: '',
        remarkValidationMsg: '',
        endPointOfZone: null,
        startPointOfZone: null,
        startPointValidationMsg: '',
        endPointValidationMsg: '',
        zoneStatus: false,
      });
    }
  }

  // Delte deck row UI
  public deleteDeck(zone: any) {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });

    this.zoneData.forEach((data, index) => {
      if (data === zone) {
        this.zoneData.splice(index, 1);
      }
    });
  }

  // go to zonelist
  changeTabs() {
    document.body.removeEventListener('keydown', this.keyDownEvent);
    this.$router.go(-1);
  }

  mounted() {
    this.init();
    document.body.addEventListener('keydown', this.keyDownEvent);
  }

  // on deck load
  onDeckLoad() {
    this.initCropper();
    this.renderLine();
  }

  // load zoom in third image container
  onDeckLoad2() {
    this.initDriftZoom();
  }

  keyDownEvent(event) {
    let e = event || window.event;
    Utils.keyDownEvent(e, this.cropper);
  }

  // initialize crop box on image
  initCropper() {
    const t = this.$refs.image as HTMLImageElement;
    const _this = this;
    this.cropper = new Cropper(t, {
      crop() {
        const data = this.cropper.getData(true);
        const index = _this.zoneData.length;
        if (_this.focusedStartPoint != null) {
          _this.zoneData[_this.focusedStartPoint].startPointOfZone = data.x;
          _this.zoneData[_this.focusedStartPoint].endPointOfZone = data.x + data.width;
          _this.zoneData[_this.focusedStartPoint].endPointValidationMsg = '';
        } else {
          _this.zoneData[index - 1].endPointOfZone = data.x + data.width;
          _this.zoneData[index - 1].endPointValidationMsg = '';

          _this.zoneData[index - 1].startPointOfZone = data.x;
          _this.zoneData[index - 1].startPointValidationMsg = '';
        }
        _this.$forceUpdate();
        _this.renderLine();
      },
      zoomable: false,
      viewMode: 2,
      data: {
        x: t.naturalWidth / 3,
        y: t.naturalHeight / 3,
        width: t.naturalWidth / 3,
        height: t.naturalHeight / 3,
      },
    });
  }
  //destroy crop box cropper
  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  //focus cursor on input box
  focusOnEndPoint(index) {
    this.focusedStartPoint = index;
  }

  //focus out cursor from input box
  blurOnEndPoint(index) {
    if (this.focusedStartPoint === index) {
      this.focusedStartPoint = null;
    }
  }

  //focus cursor on input box
  focusOnStartPoint(index) {
    this.focusedStartPoint = index;
  }

  //focus out cursor from input box
  blurOnStartPoint(index) {
    if (this.focusedStartPoint === index) {
      this.focusedStartPoint = null;
    }
  }

  //load image , then download image from server as blob then convert it into base64 to draw image on canvas
  async showDeckImage() {
    if (this.selectedShipId != null && this.shipList.length > 0 && this.deckList.length > 0 && this.deckName != '') {
      const index = this.deckList.findIndex((obj: any) => obj.drawingId == this.deckName);
      if (index != -1) {
        try {
          this.deckImageURL = '';
          this.createdImage = null;
          this.scandResult = null;
          this.isScreenLoading = true;
          this.zoneData = [
            {
              zoneName: '',
              zoneValidationMsg: '',
              remarks: '',
              remarkValidationMsg: '',
              endPointOfZone: '',
              endPointValidationMsg: '',
              startPointOfZone: null,
              startPointValidationMsg: '',
              zoneStatus: false,
            },
          ];
          this.scandResult = Utils.parseJson(this.deckList[index].scanResult);
          this.deckImageURL = await getImage(this.deckList[index].imagePath);
          this.createdImage = null;
        } catch (error) {
          this.showErrorToast({msg: 'Network Error'});
        } finally {
          this.isScreenLoading = false;
        }
      }
    }
  }

  //initialize zoomed container on hover imag
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    this.isAutomatedEnable
      ? (this.drift = new Drift(this.$refs.image2, {
          paneContainer: document.getElementById('ppppp'),
          // inlinePane: 900,
          inlineOffsetY: -85,
          containInline: true,
          handleTouch: false,
          inlinePane: false,
          zoomFactor: 5,
          hoverBoundingBox: true,
        }))
      : null;
  }
  //disable zoomed container on hover image
  disableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }

  //find zone from scaned data
  _findZones() {
    if (this.scandResult != null) {
      const zones = this.scandResult.Zones;
      this.zoneData = [];

      for (let i = 0; i < zones.length; i++) {
        let endZone = zones[i];
        let zoneCount = i + 1;

        if (
          endZone.Zone.ZoneNumber === 0 &&
          endZone.Zone.StartPoint.X === 0 &&
          endZone.Zone.EndPoint.X === 0 &&
          endZone.Zone.StartPoint.X === 0
        ) {
          this.resetZoneData();
          this.showErrorToast({msg: 'Zone markers not found in deck image'});
        } else {
          this.zoneData.push({
            zoneName: `zoneName` + ' ' + this.deckName + ' ' + zoneCount,
            zoneValidationMsg: '',
            remarks: 'remark' + ' ' + zoneCount,
            remarkValidationMsg: '',
            endPointOfZone: endZone.Zone.EndPoint.X,
            endPointValidationMsg: '',
            zoneStatus: true,
            startPointOfZone: endZone.Zone.StartPoint.X,
            startPointValidationMsg: '',
          });
        }
      }
    } else {
      this.showErrorToast({msg: 'Zones not found'});
    }
  }

  //Reset form
  resetZoneData() {
    this.zoneData = [];

    this.zoneData.push({
      zoneName: '',
      zoneValidationMsg: '',
      remarks: '',
      remarkValidationMsg: '',
      endPointOfZone: '',
      endPointValidationMsg: '',
      zoneStatus: false,
      startPointOfZone: null,
      startPointValidationMsg: '',
    });
  }

  @Watch('selectedShipId', {immediate: true})
  fetchDecks() {
    if (this.selectedShipId !== null) {
      this.resetZoneData();
      this.getDecksByShipId();
    }
  }

  //create zone blue line
  draw() {
    const data = this.zoneData;
    let lines = [];
    if (data.length > 0 && this.deckImageURL) {
      const image = this.$refs.image2 as HTMLImageElement;
      data.forEach((ele) => {
        if (ele.startPointOfZone) {
          lines.push({
            mx: ele.startPointOfZone,
            my: 0,
            x: ele.startPointOfZone,
            y: image.naturalHeight,
          });
          if (lines.length === data.length) {
            //make a copy of zone lines and orignal image
            this.mergeImage(lines);
          }
        }
      });
    }
  }

  renderLine = debounce(() => this.draw(), 500);

  //make a copy of zone lines and orignal image
  mergeImage(lines) {
    canvasMerge(this.deckImageURL, lines).then((b64) => {
      this.createdImage = b64;
      // this.initDriftZoom();
    });
  }

  @Watch('zoneData', {immediate: true})
  zoneChange(change) {
    if (change.length > 0) {
      this.renderLine();
    }
  }

  //Reset image
  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }
}
